<po-modal #modalFilter [p-title]="modalTitle" [p-primary-action]="modalPrimaryAction" p-hide-close="true" p-click-out="false" [p-secondary-action]="modalSecondaryAction">
    <!-- FORM -->
    <div *ngIf="visibilidadeBusca" class="po-row">
        <po-dynamic-form [p-fields]="filters" (p-form)="getForm($event)" (keyup.enter)="returnForm()">
        </po-dynamic-form>

        <po-button class=" po-md-12 po-sm-12" (click)="returnForm()" p-label="Buscar" p-icon="po-icon po-icon-search" p-type="primary">
        </po-button>
    </div>

    <!-- TABLE -->
    <po-table [p-items]="tableItems" [p-single-select]="singleSelect" (p-all-selected)="allSelected($event)" (p-all-unselected)="unAllSelected($event)" (p-selected)="selected($event)" (p-unselected)="unSelected($event)" [p-columns]="tableColumns" p-checkbox="true"
        p-sort="true" [p-height]="tableHeight" [p-loading]="tableLoading">
    </po-table>

    <app-pagination *ngIf="visibilidade" [(totalItems)]="totalItems" [itemsPerPage]="itemsPerPage" [(currentPage)]="currentPage" (pageChanged)="onPageChange($event)" [disabled]="tableLoading">
    </app-pagination>

</po-modal>